<template>
  <section class="bg-light d-none d-sm-block">
    <div class="container">
      <div class="row" v-scroll-reveal.reset>
        <div class="col">
          <div 
            class="d-flex flex-column flex-lg-row no-gutters border rounded bg-white o-hidden"
          >
            <a
              href="#"
              class="d-block position-relative bg-gradient col-xl-5 order-lg-2"
            >
              <div
                class="divider divider-side transform-flip-y d-none d-lg-block"
              ></div>
              <img
                class="card-img-top flex-fill hover-fade-out"
                src="assets/img/heros/hero-bukapo-1.png"
                alt="Image accompanying Amara testimonial"
              />
            </a>
            <div class="p-4 p-md-5 col-xl">
              <div class="p-lg-4 mt-4">
                <h1>
                  Semua orang bisa <br />
                  <vue-typed-js :strings="['dagang', 'menikmati', 'dagang']" :backDelay="2000" :loop="true" :backSpeed="5">
                    <span class="typing primary"></span>
                  </vue-typed-js>
                  Semua orang bisa <br />
                  <vue-typed-js :strings="['menikmati', 'dagang', 'menikmati']" :backDelay="2000" :loop="true" :backSpeed="5">
                    <span class="typing primary"></span>
                  </vue-typed-js>
                </h1>

                <p class="lead">
                  Samwell nisl purus in mollis. Varys eget velit aliquet
                  sagittis consectetur purus ut.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import VueTypedJs from "vue-typed-js";

Vue.use(VueTypedJs);

export default {
  name: "HeroSection",
    data () {
    return {
      images: [],
      mainImageSrc: null
    }
  },
  methods: {
  },
  created () {
    let self = this
    this.images = [
       {
          id: '23',
          image: 'http://example.com/img.jpg'
       },
       {
          id: '32',
          image: 'http://example.com/img.jpg'
       },
       {
          id: '45',
          image: 'http://example.com/img.jpg'
       },
    ]

    setInterval(function(){ 
        self.mainImageSrc = self.images[Math.floor(Math.random()*self.images.length)].image;
    }, 5000);

  }
};
</script>
